import { Color } from '../generated/types';

export interface ColorConfig {
    hex: string;
    name: string;
    order: number;
    class?: string;
}
export type ColorInput =
    | Color
    | keyof Color
    | Lowercase<Color>
    | Uppercase<Color>;

export const colorConfigs: Record<Color, ColorConfig> = {
    [Color.Black]: {
        hex: '#000000',
        name: 'Zwart',
        order: -4,
    },
    [Color.White]: {
        hex: '#FFFFFF',
        name: 'Wit',
        order: -3,
    },
    [Color.Gray]: {
        hex: '#545B67',
        name: 'Grijs',
        class: 'gray',
        order: -2,
    },
    [Color.Bluegray]: {
        hex: '#607D8B',
        name: 'Blauwgrijs',
        class: 'bluegray',
        order: -1,
    },
    [Color.Indigo]: {
        hex: '#3F51B5',
        name: 'Indigo',
        class: 'indigo',
        order: 0,
    },
    [Color.Blue]: {
        hex: '#2196F3',
        name: 'Blauw',
        class: 'blue',
        order: 1,
    },
    [Color.Cyan]: {
        hex: '#00BCD4',
        name: 'Cyan',
        class: 'cyan',
        order: 2,
    },
    [Color.Teal]: {
        hex: '#009688',
        name: 'Teal',
        class: 'teal',
        order: 3,
    },
    [Color.Green]: {
        hex: '#4CAF50',
        name: 'Groen',
        class: 'green',
        order: 4,
    },
    [Color.Avocado]: {
        hex: '#AEC523',
        name: 'Avocado',
        class: 'avocado',
        order: 4.5,
    },
    [Color.Yellow]: {
        hex: '#FBC02D',
        name: 'Geel',
        class: 'yellow',
        order: 5,
    },
    [Color.Orange]: {
        hex: '#F57C00',
        name: 'Oranje',
        class: 'orange',
        order: 6,
    },
    [Color.Red]: {
        hex: '#f44336',
        name: 'Rood',
        class: 'red',
        order: 7,
    },
    [Color.Pink]: {
        hex: '#E91E63',
        name: 'Rose',
        class: 'pink',
        order: 8,
    },
    [Color.Purple]: {
        hex: '#9C27B0',
        name: 'Paars',
        class: 'purple',
        order: 9,
    },
};
export const defaultColor = Color.Gray;

export function color(
    color?: ColorInput | null | undefined,
    fallback?: Color
): Color {
    fallback = fallback ?? defaultColor;
    if (typeof color !== 'string') return fallback;
    const res = color.trim().toUpperCase();
    if (res in colorConfigs) return res as Color;
    return defaultColor;
}

export function colorConfig(
    c?: ColorInput | null | undefined,
    fallback?: Color
): ColorConfig {
    return colorConfigs[color(c, fallback)];
}

export function colorHex(
    c?: ColorInput | null | undefined,
    fallback?: Color
): string {
    return colorConfig(color(c, fallback)).hex;
}
